export default [
  { path: '*', redirect: '/' },

  // Authen-Requires
  {
    path: '/',
    name: 'dash',
    meta: {
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "dashdoard" */ '@/views/Dashdoard/Index.vue')
  },

  {
    path: '/stream',
    name: 'stream',
    meta: {
      requiresAuth: true,
      title: 'Live Stream'
    },
    component: () => import(/* webpackChunkName: "stream" */ '@/views/Stream/Index.vue')
  },

  {
    path: '/users',
    name: 'users',
    redirect: {
      name: 'users.child',
      params: {
        name: 'accounts'
      }
    }
  }, {
    path: '/users/:name',
    name: 'users.child',
    meta: {
      requiresAuth: true,
      title: 'Users Permission'
    },
    component: () => import(/* webpackChunkName: "users" */ '@/views/Users/Index.vue')
  },

  {
    path: '/cog',
    name: 'cog',
    redirect: {
      name: 'cog.child',
      params: {
        name: 'cameras'
      }
    }
  }, {
    path: '/cog/:name',
    name: 'cog.child',
    meta: {
      requiresAuth: true,
      title: 'System Configuration'
    },
    component: () => import(/* webpackChunkName: "cog" */ '@/views/Cog/Index.vue'),
  },

  {
    path: '/profile',
    name: 'profile',
    redirect: {
      name: 'warning'
    }
    // meta: {
    //   requiresAuth: true,
    //   title: 'My Profile'
    // },
    // component: () => import(/* webpackChunkName: "profile" */ '@/views/Profile/Index.vue'),
  },

  // Authentication
  {
    path: '/authen',
    name: 'auth',
    meta: {
      requiresAuth: false,
      title: 'Security Rules'
    },
    component: () => import(/* webpackChunkName: "authen" */ '@/views/Authen/Index.vue')
  },

  {
    path: '/wizard',
    name: 'wizard',
    meta: {
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "wizard" */ '@/views/Wizard/Index.vue')
  },

  {
    path: '/warning',
    name: 'warning',
    meta: {
      requiresAuth: false,
      title: 'Something was wrong!!'
    },
    component: () => import(/* webpackChunkName: "warning" */ '@/views/Warning/Index.vue')
  }
]